import React from 'react';
import { Navigate } from 'react-router-dom';

const RoleGuard = ({ role,children }:{role:string;children:any;}) => {
  if (role!=='admin') {
    
    return <Navigate to="/unauthorized" />;
  }
  return children;
};
export default RoleGuard;